module.exports = __webpack_public_path__ + "static/media/france-media-monde-inside.0067de98.jpg";